import React from "react";
import '../auth.css';
import '../card.css';
import axios from 'axios';
import {reactLocalStorage} from 'reactjs-localstorage';
import { MDBContainer, MDBRow, MDBCol, MDBBtn, MDBCard, MDBCardBody } from 'mdbreact';
import Select from "react-select";
import i18n from '../i18n';
import {connect} from 'react-redux';
import Menutest from './menu.js';

import { SemanticToastContainer, toast } from 'react-semantic-toasts';
import 'react-semantic-toasts/styles/react-semantic-alert.css';
import { API_BASE_URL } from "../utils/endpoints";

var categoryOptions = [];
class AddGroup extends React.Component {


    state = {
       groupName: '',
      selectedValues: [],
      categoryselect:'',
      category_id:'',
      options_sender:[]
     }

     back=()=>
     {
      window.location="group";
     }
     onChange(values) {

      this.setState({
        selectedValues: values.id
      });
    }
    componentDidMount(){
      
      var lang=i18n.language;
      if(lang ==="ar")
      {
        document.querySelector('.title_group').style = 'text-align:right;';       
    
      
      }
      var token=reactLocalStorage.get('accessToken');
      var ip=API_BASE_URL;
      var s2 = "localhost:3000";
      var apiBaseUrl;
      if(ip.includes(s2))
      {
       apiBaseUrl =API_BASE_URL + "/core/user/rest/contacts/"+reactLocalStorage.get('user_id_login')+"/findAllCategories";     
      }
      else
      {
       apiBaseUrl = API_BASE_URL+"/core/user/rest/contacts/"+reactLocalStorage.get('user_id_login')+"/findAllCategories";
      }

      var headers = {'Content-Type': 'application/json', 'token' :token }
   axios.get(apiBaseUrl,{headers: headers})
       .then(res => {
   
         if(res.data.result.Categories !== undefined)
           {
             const dataoption=res.data.result.Categories;
             var length=res.data.result.Categories.length;
             var i;
             const newArr = this.state.options_sender;
             for(i=0;i<length;i++)
             {
              var value_option=dataoption[i].category_name;

              newArr.push({
                 label: value_option, 
                 value:dataoption[i].id
             });
               
             }
             categoryOptions= newArr;
          }
        
        })
      }

      onChangecategory= event =>{
        this.setState({categoryselect: event.label}, function () {
       });
       this.setState({category_id: event.value}, function () {
      });
      
}



     handleChange = event => {
       this.setState({ groupName: event.target.value});
 
     }
 
     handleSubmit = event => {
        event.preventDefault();
        if(this.state.category_id !== '')
        {
         
        var data={
          category_id:this.state.category_id,
          group_name:this.state.groupName
        };
      }
      else
      {
        var data={
          category_id:null,
          group_name:this.state.groupName
        };
      }
        var token=reactLocalStorage.get('accessToken');
        var ip=API_BASE_URL;
        var s2 = "localhost:3000";
        var apiBaseUrl;
      
          if(ip.includes(s2))
          {
            apiBaseUrl = API_BASE_URL + "/core/user/rest/contacts/createGroup";
          }
          else
          {
           apiBaseUrl = API_BASE_URL+"/core/user/rest/contacts/createGroup";
          }
        

        var headers = {
         'Content-Type': 'application/json',
         'token':token
          }
        axios.post(apiBaseUrl,data,{headers: headers}).then(function (response)
        {
  
        if(response.status === 200)
        {
        
    
           window.location="Group";
  
  
        }
        else if(response.status === 204){
        console.log("Something wrong");
  
        toast({
          type: 'error',
          title: i18n.t('error.label'),
          description:i18n.t('Something_wrong.label'),
          animation: 'bounce',
          time: 5000,

      });
  
        }
        else{
        console.log("Something wrong");
        toast({
          type: 'error',
          title: i18n.t('error.label'),
          description:i18n.t('Something_wrong.label'),
          animation: 'bounce',
          time: 5000,

      });
  
        }
        })
        .catch(function (error) {
        console.log(error);
        toast({
          type: 'error',
          title: i18n.t('error.label'),
          description:i18n.t('Something_wrong.label'),
          animation: 'bounce',
          time: 5000,

      });
        });
      }
      
render(){
    return(
      <div className="big_div">
      <Menutest/>
      <div className="actionMenu">
        <div>
                          <div className="add_form" style={{ paddingBottom: '2%'}}> 
                    <MDBContainer>
                    <MDBRow>
                        <MDBCol md="6">
                        <MDBCard className="add_card">
                            <MDBCardBody>
                            <form onSubmit={this.handleSubmit} className="title_group">
                                <p className="h4 text-center py-4 text_style">{i18n.t('Add_Group.label')}</p>
                                <label
                                htmlFor="defaultFormCardNameEx"
                                className="grey-text font-weight-light pink_color"
                                >
                                
                                {i18n.t('Name_of_Group.label')}
                                </label>
                                <input
                                type="text"
                                id="defaultFormCardNameEx"
                                className="form-control"
                                required="required"
                                name="title"
                                onChange={this.handleChange}
                                />
                                <br />
                                <p className="h6 pink_color">{i18n.t('Select_Category.label')}</p>
                                <Select
                                  placeholder={i18n.t('select.label')}
                                  fluid
                                  search
                                  selection
                                  options={categoryOptions}
                                  onChange={this.onChangecategory.bind(this)}
                                />
                         <br />

                                <div className="text-center py-4 mt-3">
                            
                                <button className="submit_btn_pink">

                                  <MDBBtn color="cyan"  onClick={this.back}>
                                  {i18n.t('Back.label')}
                                  </MDBBtn>
                                  </button>

                                <button className="submit_btn_pink">
                                    <MDBBtn color="cyan" type="submit">
                                    {i18n.t('Submit.label')}
                                    </MDBBtn>
                                    </button>

                                </div>
                            </form>
                            </MDBCardBody>
                        </MDBCard>
                        </MDBCol>
                    </MDBRow>
                    </MDBContainer>
                    <SemanticToastContainer/>
                    </div>
        </div> </div> </div>
    );
}

}


const mapStateToProps = (state)=>{
  return {...state}
}
export default connect(mapStateToProps) (AddGroup);
